import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Alert from '@material-ui/lab/Alert';

import { PersonContext } from '~/contexts/PersonContext';
import { get } from '~/feathersFunctionalWrapper';

function ImpersonateFromIntercom() {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const { setAdminUserSelect } = useContext(PersonContext);

  const { search } = useLocation();
  const query = new URLSearchParams(search);

  useEffect(() => {
    const loadUser = async () => {
      // In the TurboTenant Intercom workspace the contact's user_id is `ReiHub:{id}`; accept it
      // as well as the plain id so the impersonation link works with either template.
      const userId = (query.get('userId') || '').replace(/^ReiHub:/, '');

      if (!userId) {
        setHasError(true);
        return;
      }

      try {
        const userResponse = await get('users', userId);
        setUser(userResponse);
      } catch {
        setHasError(true);
      } finally {
        setIsLoading(false);
      }
    };
    loadUser();
  }, []);

  useEffect(() => {
    if (user) {
      setAdminUserSelect({ id: user.id });
    }
  }, [user]);

  if (isLoading) {
    return null;
  }

  if (hasError) {
    return <Alert severity="error">Error loading user</Alert>;
  }

  return (
    <Alert severity="info">
      Impersonating {user.firstName} {user.lastName}
    </Alert>
  );
}

export default ImpersonateFromIntercom;
